<!--
 * @Author:
 * @LastEditTime: 2022-04-18 18:25:50
 * @Description: 新增、编辑身份资源
-->
<template>
  <el-dialog
    v-dialogDrag
    width="565px"
    :close-on-click-modal="false"
    :append-to-body="true"
    :visible.sync="operateIdentityProps.visible"
    :title="operateIdentityProps.title"
    class="mini-dialog"
  >
    <el-form
      size="mini"
      label-width="150px"
      v-loading="formLoading"
      :rules="apiRules"
      ref="identityForm"
      :model="identityForm"
    >
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="identityForm.name"
          :readonly="operateIdentityProps.editType === 'edit'"
          placeholder="请输入名称"
          size="small"
          clearable
        />
      </el-form-item>
      <el-form-item label="显示名称" prop="displayName">
        <el-input
          v-model="identityForm.displayName"
          placeholder="请输入显示名称"
          size="small"
          clearable
        />
      </el-form-item>
      <el-form-item label="身份声明" prop="userClaims">
        <el-select
          size="small"
          multiple
          filterable
          clearable
          v-model="identityForm.userClaims"
          class="w-full"
        >
          <el-option
            v-for="item in claimTypes"
            :key="item.id"
            :value="item.name"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input
          v-model="identityForm.description"
          placeholder="请输入描述"
          size="small"
          clearable
        />
      </el-form-item>
      <el-form-item label="启用" prop="enabled">
        <el-checkbox v-model="identityForm.enabled" />
      </el-form-item>
      <el-form-item label="在发现文档中显示" prop="showInDiscoveryDocument">
        <el-checkbox v-model="identityForm.showInDiscoveryDocument" />
      </el-form-item>
      <el-form-item label="重要" prop="emphasize">
        <el-checkbox v-model="identityForm.emphasize" />
      </el-form-item>
      <el-form-item label="必须" prop="required">
        <el-checkbox v-model="identityForm.required" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button size="small" type="primary" class="iconfont icon-save" @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="cancel()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { IdentityResourceApi } from '@wiz-api/auth-server'
import { ClaimTypeApi } from '@wiz-api/account'

const identityResourceApi = new IdentityResourceApi()
const claimTypeApi = new ClaimTypeApi()

export default {
  name: 'operateApiScopeDialog',
  props: {
    operateIdentityProps: {
      type: Object,
      default: () => {
        return {
          title: '新增身份资源',
          editType: 'create',
          visible: false,
        }
      },
    },
    identityForm: {
      type: Object,
      default: () => {
        return {
          name: '',
          displayName: '',
          description: '',
          userClaims: [],
          enabled: true,
          showInDiscoveryDocument: true,
        }
      },
    },
  },
  components: {},
  data() {
    return {
      formLoading: false,
      claimTypes: [], // 声明集
      apiRules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: ['blur', 'change'],
          },
        ],
        displayName: [
          {
            required: true,
            message: '请输入显示名称',
            trigger: ['blur', 'change'],
          },
        ],
        userClaims: [
          {
            required: true,
            message: '请选择身份声明',
            trigger: ['blur', 'change'],
          },
        ],
      },
    }
  },
  computed: {},
  methods: {
    async findClaimTypes() {
      this.formLoading = true
      const [err, res] = await claimTypeApi.getAllList()
      this.formLoading = false
      if (!err) {
        this.claimTypes = res
        this.initClaimTypes = _.cloneDeep(this.claimTypes)
      }
    },
    cancel() {
      this.operateIdentityProps.visible = false
    },
    save() {
      this.$refs.identityForm.validate(async (valid) => {
        if (valid) {
          if (this.operateIdentityProps.editType === 'create') {
            const [err, res] = await identityResourceApi.create({ body: this.identityForm })
            if (!err) {
              this.$message.success({
                showClose: true,
                message: '新增成功',
              })
              this.operateIdentityProps.visible = false
              this.$emit('refreshList')
            }
            return
          }
          const [updateErr, updateRes] = await identityResourceApi.update(this.identityForm.id, {
            body: this.identityForm,
          })
          if (!updateErr) {
            this.$message.success({
              showClose: true,
              message: '修改成功',
            })
            this.operateIdentityProps.visible = false
            this.$emit('refreshList')
          }
        }
      })
    },
  },
  created() {
    this.findClaimTypes()
  },
}
</script>

<style scoped lang="scss"></style>
